import { render, staticRenderFns } from "./GuestBox.vue?vue&type=template&id=a6d23ecc&scoped=true&"
import script from "./GuestBox.vue?vue&type=script&lang=js&"
export * from "./GuestBox.vue?vue&type=script&lang=js&"
import style0 from "./GuestBox.vue?vue&type=style&index=0&id=a6d23ecc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6d23ecc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a6d23ecc')) {
      api.createRecord('a6d23ecc', component.options)
    } else {
      api.reload('a6d23ecc', component.options)
    }
    module.hot.accept("./GuestBox.vue?vue&type=template&id=a6d23ecc&scoped=true&", function () {
      api.rerender('a6d23ecc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-27PxknmH63rZn/JS/comp/GuestBox.vue"
export default component.exports